const EnumOverral = {
  ACCEPTANCE: "Acceptance",
  CONDITIONAL_ACCEPTANCE: "ConditionalAcceptance",
  MINOR_REVISION: "MinorRevision",
  MAJOR_REVISION: "MajorRevision",
  REJECTION: "Rejection",
  REJECTION_INAPPROPRIATE: "Rejection_Inappropriate",
};
export default EnumOverral;
